<template>
  <v-row justify="center">
    <v-dialog v-model="modal" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark :color="colorback">
          <v-btn icon dark @click="$emit('click', false)" class="closemodal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer> -->
        </v-toolbar>
        <v-card-text>
            <v-flex>
                <slot></slot>
            </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'modalApp',
  model: {
    prop: 'modal',
    event: 'click'
  },
  props: {
    modal: Boolean
  },
  data () {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      openModal: false,
      colorback: 'rgb(0, 11, 140)'
    }
  },
  methods: {
  },
  watch: {
    openModal: function (value) {
      // console.log(value)
      this.dialog = value
    }
  }
}
</script>
<style lang="scss" scoped>
.closemodal{
    margin-right: 0 auto!important;
}

</style>
